export const COGNOS_DISPLAYED_COLUMNS = [
  'select',
  'fileName',
  'year',
  'month',
  'periodDescription',
  'download'
];
